import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadFellowship: IFellowshipLoadActionCreator = () => {
        return {
            type: ACTION_FELLOWSHIP_LOAD
        }
    },
    LoadFellowshipById: IFellowshipLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_FELLOWSHIP_LOAD_BY_ID,
            id
        }
    },
    LoadFellowshipsByPersonnelId: IFellowshipsLoadByPersonnelIdActionCreator = (personnelId) => {
        return {
            type: ACTION_FELLOWSHIP_LOAD_BY_PERSONNEL_ID,
            personnelId
        }
    },
    LoadSuccess: IFellowshipLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_FELLOWSHIP_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: IFellowshipLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_FELLOWSHIP_LOAD_FAILURE,
            responseStatus
        }
    },


    SaveFellowship: IFellowshipSaveActionCreator = (formData) => {
        return {
            type: ACTION_FELLOWSHIP_SAVE,
            formData
        }
    },
    SaveSuccess: IFellowshipSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_FELLOWSHIP_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: IFellowshipSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_FELLOWSHIP_SAVE_FAILURE,
            responseStatus
        }
    },

    CreateFellowship: IFellowshipCreateActionCreator = (personnelId) => {

        return {
            type: ACTION_FELLOWSHIP_CREATE,
            personnelId
        }
    },
    CreateSuccess: IFellowshipCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_FELLOWSHIP_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: IFellowshipCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_FELLOWSHIP_CREATE_FAILURE,
            responseStatus
        }
    },

    ValidateFellowship: IFellowshipValidateActionCreator = (formData) => {
        return {
            type: ACTION_FELLOWSHIP_VALIDATE,
            formData
        }
    },
    ValidateSuccess: IFellowshipValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_FELLOWSHIP_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: IFellowshipValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_FELLOWSHIP_VALIDATE_FAILURE,
            responseStatus
        }
    },

    Clear: IFellowshipClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_FELLOWSHIP_CLEAR,
            propertiesToClear
        }
    },

    Filter: IFellowshipFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_FELLOWSHIP_FILTER,
            formFilter
        }
    };



export const
    ACTION_FELLOWSHIP_LOAD = "ACTION_FELLOWSHIP_LOAD",
    ACTION_FELLOWSHIP_LOAD_BY_ID = "ACTION_FELLOWSHIP_LOAD_BY_ID",
    ACTION_FELLOWSHIP_LOAD_BY_PERSONNEL_ID = "ACTION_FELLOWSHIP_LOAD_BY_PERSONNEL_ID",
    ACTION_FELLOWSHIP_LOAD_SUCCESS = "ACTION_FELLOWSHIP_LOAD_SUCCESS",
    ACTION_FELLOWSHIP_LOAD_FAILURE = "ACTION_FELLOWSHIP_LOAD_FAILURE",

    ACTION_FELLOWSHIP_SAVE = "ACTION_FELLOWSHIP_SAVE",
    ACTION_FELLOWSHIP_SAVE_SUCCESS = "ACTION_FELLOWSHIP_SAVE_SUCCESS",
    ACTION_FELLOWSHIP_SAVE_FAILURE = "ACTION_FELLOWSHIP_SAVE_FAILURE",

    ACTION_FELLOWSHIP_CREATE = "ACTION_FELLOWSHIP_CREATE",
    ACTION_FELLOWSHIP_CREATE_SUCCESS = "ACTION_FELLOWSHIP_CREATE_SUCCESS",
    ACTION_FELLOWSHIP_CREATE_FAILURE = "ACTION_FELLOWSHIP_CREATE_FAILURE",

    ACTION_FELLOWSHIP_VALIDATE = "ACTION_FELLOWSHIP_VALIDATE",
    ACTION_FELLOWSHIP_VALIDATE_SUCCESS = "ACTION_FELLOWSHIP_VALIDATE_SUCCESS",
    ACTION_FELLOWSHIP_VALIDATE_FAILURE = "ACTION_FELLOWSHIP_VALIDATE_FAILURE",

    ACTION_FELLOWSHIP_CLEAR = "ACTION_FELLOWSHIP_CLEAR",

    ACTION_FELLOWSHIP_FILTER = "ACTION_FELLOWSHIP_FILTER";

export interface IFellowshipLoadAction {
    type: "ACTION_FELLOWSHIP_LOAD";
}

export interface IFellowshipLoadActionCreator {
    (): IFellowshipLoadAction;
}

export interface IFellowshipLoadSuccessAction {
    type: "ACTION_FELLOWSHIP_LOAD_SUCCESS";
    formData: Dtos.Fellowship | Dtos.Fellowship[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface IFellowshipLoadSuccessActionCreator {
    (
        formData: Dtos.Fellowship | Dtos.Fellowship[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IFellowshipLoadSuccessAction;
}

export interface IFellowshipLoadFailureAction {
    type: "ACTION_FELLOWSHIP_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IFellowshipLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IFellowshipLoadFailureAction;
}

export interface IFellowshipLoadByIdAction {
    type: "ACTION_FELLOWSHIP_LOAD_BY_ID";
    id: number;
}

export interface IFellowshipLoadByIdActionCreator {
    (id: number): IFellowshipLoadByIdAction;
}

export interface IFellowshipsLoadByPersonnelIdAction {
    type: "ACTION_FELLOWSHIP_LOAD_BY_PERSONNEL_ID";
    personnelId: number;
}

export interface IFellowshipsLoadByPersonnelIdActionCreator {
    (personnelId: number): IFellowshipsLoadByPersonnelIdAction;
}

export interface IFellowshipSaveAction {
    type: "ACTION_FELLOWSHIP_SAVE";
    formData: Dtos.Fellowship;

}

export interface IFellowshipSaveActionCreator {
    (
        formData: Dtos.Fellowship
    ): IFellowshipSaveAction;
}

export interface IFellowshipSaveSuccessAction {
    type: "ACTION_FELLOWSHIP_SAVE_SUCCESS";
    formData: Dtos.Fellowship;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IFellowshipSaveSuccessActionCreator {
    (
        formData: Dtos.Fellowship,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IFellowshipSaveSuccessAction;
}

export interface IFellowshipSaveFailureAction {
    type: "ACTION_FELLOWSHIP_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IFellowshipSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IFellowshipSaveFailureAction;
}

export interface IFellowshipCreateAction {
    type: "ACTION_FELLOWSHIP_CREATE",
    personnelId: number
}

export interface IFellowshipCreateActionCreator {
    (personnelId: number): IFellowshipCreateAction,
}

export interface IFellowshipCreateSuccessAction {
    type: "ACTION_FELLOWSHIP_CREATE_SUCCESS";
    formData: Dtos.Fellowship;
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
}

export interface IFellowshipCreateSuccessActionCreator {
    (
        formData: Dtos.Fellowship,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): IFellowshipCreateSuccessAction;
}

export interface IFellowshipCreateFailureAction {
    type: "ACTION_FELLOWSHIP_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IFellowshipCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IFellowshipCreateFailureAction;
}

export interface IFellowshipValidateAction {
    type: "ACTION_FELLOWSHIP_VALIDATE";
    formData: Dtos.Fellowship;

}

export interface IFellowshipValidateActionCreator {
    (
        formData: Dtos.Fellowship
    ): IFellowshipValidateAction;
}

export interface IFellowshipValidateSuccessAction {
    type: "ACTION_FELLOWSHIP_VALIDATE_SUCCESS";
    formData: Dtos.Fellowship;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IFellowshipValidateSuccessActionCreator {
    (
        formData: Dtos.Fellowship,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IFellowshipValidateSuccessAction;
}

export interface IFellowshipValidateFailureAction {
    type: "ACTION_FELLOWSHIP_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IFellowshipValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IFellowshipValidateFailureAction;
}

export interface IFellowshipClearAction {
    type: "ACTION_FELLOWSHIP_CLEAR";
    propertiesToClear?: string[];
}

export interface IFellowshipClearActionCreator {
    (propertiesToClear?: string[]): IFellowshipClearAction;
}

export interface IFellowshipFilterActionCreator {
    (formFilter: IFormFilter): IFellowshipFilterAction;
}

export interface IFellowshipFilterAction {
    type: "ACTION_FELLOWSHIP_FILTER";
    formFilter: IFormFilter;
}

export type FellowshipAction =
    IFellowshipLoadAction |
    IFellowshipLoadByIdAction |
    IFellowshipsLoadByPersonnelIdAction |
    IFellowshipLoadFailureAction |
    IFellowshipLoadSuccessAction |
    IFellowshipSaveAction |
    IFellowshipSaveSuccessAction |
    IFellowshipSaveFailureAction |
    IFellowshipCreateAction |
    IFellowshipCreateSuccessAction |
    IFellowshipCreateFailureAction |
    IFellowshipValidateAction |
    IFellowshipValidateSuccessAction |
    IFellowshipValidateFailureAction |
    IFellowshipClearAction |
    IFellowshipFilterAction;
